import { FC, memo } from 'react'
import { useField } from 'react-final-form'
import { Button, Label } from '@cargomart/ui'
import {
  compose,
  FieldFormItem,
  FieldIMask,
  FieldMobilePhone,
  Form,
  phoneNumberValid,
  required,
  alphabetSymbolsAllow,
  maxChar
} from 'forms'
import { checkFieldError } from 'helpers/form'
import { useIsMobile } from 'hooks'
import { FieldText } from 'shared/forms'
import { ModalFooter } from 'src/tailwind-components/extends/Modal'
import { PlaceholderCell } from 'src/tailwind-components/extends/PlaceholderCell'

import { INITIAL_VALUES } from './constants'
import { ContactCreateFormProps } from './types'

const ContactCreateForm: FC<ContactCreateFormProps> = (props) => {
  const { onClose, isCreating, createContact } = props
  const isMobile = useIsMobile()

  return (
    <Form
      keepDirtyOnReinitialize
      initialValues={INITIAL_VALUES}
      onSubmit={createContact}
      render={(form) => (
        <form onSubmit={form.handleSubmit}>
          <div className="grid grid-cols-3 justify-between gap-2">
            <FieldFormItem label={<Label className="pt-2">Фамилия</Label>} name="lastname">
              <FieldText
                disabled={isCreating}
                name="lastname"
                testId="contacts-page--form--lastname-input"
                validate={compose(required, alphabetSymbolsAllow, maxChar(100))}
              />
            </FieldFormItem>
            <FieldFormItem label={<Label className="pt-2">Имя</Label>} name="firstname">
              <FieldText
                disabled={isCreating}
                name="firstname"
                testId="contacts-page--form--firstname-input"
                validate={compose(required, alphabetSymbolsAllow, maxChar(100))}
              />
            </FieldFormItem>
            <FieldFormItem label={<Label className="pt-2">Отчество</Label>} name="secondname">
              <FieldText
                disabled={isCreating}
                name="secondname"
                placeholder="При наличии"
                testId="contacts-page--form--secondname-input"
                validate={compose(alphabetSymbolsAllow, maxChar(100))}
              />
            </FieldFormItem>
          </div>
          <div className="grid grid-cols-2 justify-between gap-2">
            <FieldFormItem label={<Label className="pt-2">Телефон</Label>} name="phone">
              <FieldMobilePhone
                className="!h-8"
                disabled={isCreating}
                maskType="city"
                name="phone"
                size="lg"
                testId="contacts-page--form--phone-input"
                validate={compose(required, phoneNumberValid)}
              />
            </FieldFormItem>
            <FieldPhoneExt isCreating={isCreating} />
          </div>
          <ModalFooter className="gap-2 !px-0 !py-6">
            {!isMobile && (
              <Button loading={isCreating} onClick={onClose} size="lg" variant="outline">
                Отменить
              </Button>
            )}
            <Button
              loading={isCreating}
              size="lg"
              type="submit"
              variant="solid"
              data-test-id="contacts-page--form--save-btn"
            >
              Добавить
            </Button>
          </ModalFooter>
        </form>
      )}
    />
  )
}

// eslint-disable-next-line @cargomart/react-component-name
export const FieldPhoneExt: FC<{ isCreating: boolean; isLoading?: boolean }> = ({ isCreating, isLoading = false }) => {
  const { meta: phoneExtMeta } = useField('phoneExt')

  return (
    <FieldFormItem className="grow" label={<Label className="pt-2">Доб. номер</Label>} name="phoneExt">
      {isLoading ? (
        <PlaceholderCell height={32} />
      ) : (
        /* TODO заменить на компонент из формы */
        <FieldIMask
          className="grow"
          disabled={isCreating}
          mask="000000"
          name="phoneExt"
          testId="contacts-page--form--phone-ext-input"
        />
      )}
      {!checkFieldError(phoneExtMeta) && <div className="pt-1 text-body-sm text-on-surface-variant">Необязательно</div>}
    </FieldFormItem>
  )
}
export default memo(ContactCreateForm)
